import React, { useState } from "react";
import { useStaticQuery, Link, graphql } from "gatsby";
import styled from "styled-components";
import { StaticImage } from "gatsby-plugin-image";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";

const color = {
  black: "#282a36",
  white: "#f8f8f2",
  green: "#50fa7b",
  orange: "#ffb86c",
  pink: "#ff79c6",
  purple: "#bd93f9",
};
const linkColors = {
  green: "#50fa7b",
  orange: "#ffb86c",
  pink: "#ff79c6",
  purple: "#bd93f9",
};
const NavigationContainer = styled.div`
  color: ${color.white};

  /* @media (max-width: 768px) {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;

    text-align: center;
    align-items: center;
    justify-content: center;
    z-index: 100;

    &.active {
      z-index: 1;
    }
    &.active .navigation__container {
      transform: translateX(0);
    }
    &.active #navMenu--btn {
      opacity: 0;
      transition: all 0.2s ease-in-out;
      transform: rotate(45deg);
    }
    &.active #navMenu--close {
      opacity: 1;
      transition: all 0.2s ease-in-out;
      transform: rotate(90deg);
    }
  } */
`;

const Navigation = styled.nav`
  flex-direction: row;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 1rem;

  > a {
    font-size: 1rem;
    color: ${props => props.color.white};
    margin: 0 10px 15px;
    display: block;
    /* box-shadow: none; */
    /* text-align: center; */
    /* line-height: 1.2; */
  }

  /* @media (max-width: 768px) {
    width: 100%;
    height: auto;
    position: absolute;
    top: 100px;
    left: 0;
    z-index: 100;
    transform: translateX(-100%);
    transform: translateX(0);

    &.active {
      transform: translateX(0);
    }
  } */
`;
const LinkColor = styled.span`
  color: ${props => props.color};
`;

export default () => {
  const data = useStaticQuery(graphql`
    query NavigationSimpleQuery {
      site {
        siteMetadata {
          siteTitle
          menuLinks {
            link
            name
          }
          subMenu {
            link
            name
          }
        }
      }
      profileImage: file(relativePath: { eq: "profile-pic.jpg" }) {
        childImageSharp {
          gatsbyImageData(
            width: 75
            placeholder: BLURRED
            formats: [AUTO, WEBP, AVIF]
          )
        }
      }
    }
  `);

  const { siteTitle, menuLinks } = data.site.siteMetadata;
  const [menuActive, setMenuActive] = useState(false);
  function navClick() {
    if (menuActive === true) {
      setMenuActive(false);
      document.querySelector("body").classList.remove("overflow-hidden");
    } else {
      setMenuActive(true);
      document.querySelector("body").classList.add("overflow-hidden");
    }
  }

  return (
    <NavigationContainer color={color}>
      <Navigation color={color}>
        {menuLinks.map(function(element, item) {
          return (
            <Link
              stlye="width: 100%;"
              to={element.link}
              activeClassName="active"
            >
              <LinkColor color={color.black}>{element.name}</LinkColor>
            </Link>
          );
        })}
      </Navigation>
      {/* <ProfileImgContainer color={color}>
        <ProfileImg>
          <StaticImage
            src="../../content/assets/profile-pic.jpg"
            alt="chris shimmin profile picture"
            placeholder="blurred"
            layout="fixed"
            width={75}
            height={75}
          />
        </ProfileImg>
        <Link stlye="width: 100%;" to="/"></Link>
      </ProfileImgContainer> */}
      {/* <NavBtn id="navMenu--btn" onClick={navClick}>
        <FontAwesomeIcon icon={faBars} size="2x" />
      </NavBtn>
      <CloseBtn id="navMenu--close" onClick={navClick}>
        <FontAwesomeIcon icon={faTimes} size="2x" tabIndex="0" />
      </CloseBtn> */}

      {/* <Container
        color={color}
        className={`navigation__container ${menuActive ? "active" : ""}`}
        onClick={navClick}
      >
        <Header>
          <Link to="/">
            <WhiteA color={color}>{siteTitle}</WhiteA>
          </Link>
        </Header>
        <Navigation color={color}>
          {menuLinks.map(function(element, item) {
            return (
              <Link
                stlye="width: 100%;"
                to={element.link}
                activeClassName="active"
              >
                <LinkColor color={linkColors[Object.keys(linkColors)[item]]}>
                  {element.name}
                </LinkColor>
              </Link>
            );
          })}
        </Navigation>
      </Container> */}
    </NavigationContainer>
  );
};
